
export default {
  props: {
    formId: {
      type: Number,
      required: true,
    },
    darkBg: {
      type: Boolean,
    },
    buttonCentered: {
      type: Boolean,
    },
  },
  data: () => ({
    form: {},
    formFields: [],
    loading: false,
    requiredCheckboxes: [],
    originalFields: [],
    turnstileToken: null,
  }),
  async created() {
    const {data} = await this.$axios.get(`/forms/${this.formId}`);
    const template = data.data;

    template.fields.forEach((field) => {
      if (field.type === 'checkbox') {
        this.form[field.name] = [];
        if (field.required) {
          this.requiredCheckboxes.push(field.name);
        }
      } else {
        this.form[field.name] = null;
      }
    });

    this.formFields = template.fields;
    this.originalFields = template.fields;
  },
  methods: {
    async submit() {
      this.loading = true;

      const form = Object.fromEntries(Object.entries(this.form).map(([name, value]) => [
        name,
        this.requiredCheckboxes.includes(name) ? [value] : value,
      ]));
      const submission = {...form, 'cf-turnstile-response': this.turnstileToken};

      try {
        await this.$axios.post('/forms/' + this.formId, submission);
        this.$formulate.reset(`dynamic-form-${this.formId}`);
        if (this.$listeners['event:success']) {
          this.$emit('event:success');
        } else {
          this.$toast.success(this.$t('Form has been submitted.'));
        }
      } catch (e) {
        console.error(e);

        if (this.$listeners['event:error']) {
          this.$emit('event:error');
        } else {
          this.$toast.error(this.$t('Something went wrong while submitting the form. Try again later.'));
        }
      } finally {
        this.loading = false;
        this.$refs.turnstile?.reset();
      }
    },
  },
};
